import { Grid, IconButton } from "@mui/material";
import UtlModalTitle from "./MxModalTitle";
import useModal from "../../../base/modal/useModal";
import { IconX } from "@tabler/icons-react";

export interface IMxModalHeaderProps {}
function MxModalHeader(props: IMxModalHeaderProps) {
  const { onDismiss, getOptions } = useModal();
  const options = getOptions();
  if (options?.disableHeader) {
    return null;
  }
  return (
    <Grid container item xs={12} alignItems="center">
      {options?.title && (
        <Grid item justifyContent={"flex-start"} textAlign={"left"}>
          <UtlModalTitle title={options.title} />
        </Grid>
      )}
      <Grid item flex={1} />
      {!options?.disableCloseButton && (
        <IconButton
          onClick={onDismiss}
          sx={{
            color: "grey.400",
            background: "rgba(255,255,255,0.5)",
            transition: "0.3s ease-in-out",
            "&:hover": {
              rotate: "360deg",
              transition: "0.3s ease-in-out",
              color: "primary.main"
            }
          }}
        >
          <IconX />
        </IconButton>
      )}
    </Grid>
  );
}

export default MxModalHeader;
